var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 24",
    style: {
      enableBackground: "new 0 0 25 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.6,21.4c-0.3,0-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7c0-0.2,0-5,3.9-6.3C7,14,7.5,14.3,7.7,14.8c0.2,0.5-0.1,1.1-0.6,1.3 c-1.5,0.5-2.1,2.1-2.4,3.2c1.1-0.2,2.7-0.8,3.2-2.4c0.2-0.5,0.7-0.8,1.3-0.6c0.5,0.2,0.8,0.7,0.6,1.3C8.6,21.4,3.8,21.4,3.6,21.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.7,3.8c-0.1-0.4-0.2-0.7-0.5-1c-0.3-0.3-0.6-0.4-1-0.5c-1.1-0.2-3.9-0.2-6.7,2.5l-0.8,0.8H7.1c-0.2,0-0.5,0-0.7,0.1 C6.2,5.9,6,6,5.8,6.2l-3,3C2.6,9.4,2.4,9.7,2.3,10c-0.1,0.3-0.1,0.6,0,0.9c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.4 l3.6,0.7l3.8,3.8l0.7,3.6c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.2,0.5,0.4,0.8,0.5c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4-0.1 c0.3-0.1,0.6-0.2,0.8-0.5l3-3c0.2-0.2,0.3-0.3,0.4-0.6c0.1-0.2,0.1-0.4,0.1-0.7v-5.6l0.8-0.8C21.9,7.8,21.8,4.9,21.7,3.8z M7.2,7.6 h3.5l-3.2,3.2l-2.9-0.6L7.2,7.6z M16.4,16.8l-2.7,2.7l-0.6-2.9l3.2-3.2L16.4,16.8z M17.7,9.1l-1,1l-0.1,0.1l-4.5,4.6l-2.8-2.8 l4.6-4.5c0,0,0.1-0.1,0.1-0.1l1-1c2-2,3.9-2.1,4.8-2c0,0.1,0,0.3,0,0.5C19.7,5.8,19.4,7.4,17.7,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon-rocket.b2b6b6e50a6f00a086cf466249dd0b25.svg";
export { ForwardRef as ReactComponent };